import './App.css';
import '@near-wallet-selector/modal-ui/styles.css';

import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { accountBalance, logout as destroy } from './components/utils/near';
import { useCallback, useEffect, useState } from 'react';

import { Add_Quiz } from './components/utils/quiz';
import CreateQuiz from './components/quiz/CreateQuiz';
import { Flowbite } from 'flowbite-react';
import Footer from './components/Footer';
import Home from './components/quiz/Home';
import Navbar from './components/Navbar';
import { Notification } from './components/utils/Notifications';
import Profile from './components/Profile';
import QuizPage from './components/quiz/QuizPage';
import Result from './components/quiz/Result';
import ViewPage from './components/quiz/ViewPage';
import { WalletSelectorContextProvider } from './components/utils/WalletSelectorContext';
import i18n from './i18n';
import { toast } from 'react-toastify';

// import View from './components/quiz/viewQuiz';

const App = function AppWrapper() {
  const account = window.walletConnection.account();
  const [balance, setBalance] = useState('0');
  const getBalance = useCallback(async () => {
    if (account.accountId) {
      setBalance(await accountBalance());
    }
  }, [account]);

  useEffect(() => {
    getBalance();
    // console.log('nth')
  }, [getBalance]);

  const add_quiz = async (quiz, money) => {
    try {
      await Add_Quiz({ quiz }, money);
      toast.success(
        i18n.language === 'en'
          ? 'Quiz Added Successfully'
          : 'تمت إضافة الاختبار بنجاح'
      );
    } catch (error) {
      console.log(error);
      toast.error(
        i18n.language === 'en' ? "Couldn't add quiz" : 'لم يتم إضافة الاختبار'
      );
    }
  };

  return (
    <div className='min-h-screen dark:bg-dark-700 dark:text-slate-100'>
      <Notification />
      <div className='container'>
        <Flowbite>
          <WalletSelectorContextProvider>
            <Router>
              <Navbar address={account.accountId} />

              <Routes>
                <Route path='/' element={<Home acc={account} />} />
                <Route
                  path='/profile'
                  element={
                    <Profile
                      account={account}
                      balance={balance}
                      logout={destroy}
                    />
                  }
                />
                <Route
                  path='/create'
                  element={<CreateQuiz acc={account} save={add_quiz} />}
                />
                <Route path='/quiz/:id' element={<QuizPage acc={account} />} />
                <Route path='/view/:id' element={<ViewPage acc={account} />} />
                <Route path='/result' element={<Result />} />
              </Routes>
              <Footer />
            </Router>
          </WalletSelectorContextProvider>
        </Flowbite>
      </div>
    </div>
  );
};

export default App;
